// extracted by mini-css-extract-plugin
export default {"toggle":"WjMSW1","track":"sSDrt6","checked":"rzkaAb","thumb":"zfEPmP","check":"bvZAYK","cross":"MorMIw"};